export const SET_VIDEO = "SET_VIDEO";

export const setVideo = (video) => {
  return {
    type: SET_VIDEO,
    payload: video,
  };
};
